import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { useI18n } from "@/i18n";

function updateGAConsent(granted) {
  if (typeof window.gtag === "function") {
    const state = granted ? "granted" : "denied";
    window.gtag("consent", "update", {
      analytics_storage: state,
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
    });
  }
}

export default function CookieConsent() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = localStorage.getItem("bh_consent");
    if (c === "granted") updateGAConsent(true);
    // Don't bother the team inside the admin area.
    if (!c && !window.location.pathname.startsWith("/admin")) setVisible(true);
  }, []);

  const decide = (granted) => {
    localStorage.setItem("bh_consent", granted ? "granted" : "denied");
    updateGAConsent(granted);
    if (granted) {
      window.dispatchEvent(new Event("bh-consent-granted"));
      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
          page_path: window.location.pathname + window.location.search,
          page_location: window.location.href,
          page_title: document.title,
        });
      }
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] w-[calc(100%-2rem)] max-w-3xl"
    >
      <div className="bg-[#1a2d56] text-white rounded-2xl shadow-2xl ring-1 ring-white/10 p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <span className="w-9 h-9 rounded-xl bg-[#d7de3b] text-[#1a2d56] flex items-center justify-center shrink-0">
            <Cookie size={18} />
          </span>
          <div>
            <p className="font-head font-bold text-sm">{t("cookie_title")}</p>
            <p className="mt-1 text-sm text-white/75 leading-relaxed">
              {t("cookie_text")}{" "}
              <a
                href="/confidentialite"
                data-testid="cookie-privacy-link"
                className="underline hover:text-[#d7de3b]"
              >
                {t("cookie_privacy")}
              </a>
            </p>
          </div>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-refuse"
            onClick={() => decide(false)}
            className="px-5 py-2.5 rounded-full text-sm font-semibold border border-white/30 text-white hover:bg-white/10 transition-colors"
          >
            {t("cookie_refuse")}
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide(true)}
            className="px-5 py-2.5 rounded-full text-sm font-bold bg-[#d7de3b] text-[#1a2d56] hover:-translate-y-0.5 transition-transform"
          >
            {t("cookie_accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
